module.exports = __webpack_public_path__ + "img/spb.85ea3e3d.png";